import { render, staticRenderFns } from "./el-menu-items-collapse.vue?vue&type=template&id=4c215524&scoped=true&"
import script from "./el-menu-items-collapse.vue?vue&type=script&lang=ts&"
export * from "./el-menu-items-collapse.vue?vue&type=script&lang=ts&"
import style0 from "./el-menu-items-collapse.vue?vue&type=style&index=0&id=4c215524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c215524",
  null
  
)

export default component.exports